import React from 'react';
import PropTypes from 'prop-types';
import { useController } from '@rest-hooks/react';
import { useParams } from 'react-router-dom';

import PaypalResource from 'resources/Profile/PaypalResource';
import MembershipResource from "resources/Profile/MembershipResource";
import ProfileResource from "resources/Profile/ProfileResource";
import ProductResource from "resources/Profile/ProductResource";

import OrderSummary from "components/OrderSummary";

import { useError } from 'utils/useErrorController';

import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

import { t } from "i18n/index";

const style = {
  layout: "vertical",
  color: "gold",
  label: "buynow",
  disableMaxWidth: true
};

const PaypalPaymentForm = ({
  items,
  createOrder,
  onShowTickets,
  onStepChange,
  onContentChange
}) => {

  const { setLoading, loading, handleError } = useError();
  const { organizationSlug } = useParams();
  const { fetch } = useController();

  const currency = items[0]?.product?.organization?.currency;
  const frequency = items[0]?.frequency ?? "lifetime";

  const initialOptions = {
    "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
    currency: currency,
    intent: "capture",
  };

  const handlePaypalPaymentApproval = async (data) => {
    try {
      const response = await fetch(PaypalResource.detail(), { organization_slug: organizationSlug, id: data.orderID });

      const {order_id_main, uuids, order_id, content_text, ga_data, fb_data} = response;

      if (order_id === order_id_main) {

        if (uuids) onShowTickets(uuids);

        await fetch(MembershipResource.list(), {
          organization_slug: organizationSlug,
        });
        await fetch(ProfileResource.detail(), {
          id: organizationSlug,
        });
        await fetch(ProductResource.list(), {
          organization_slug: organizationSlug,
        })

        if (window.trackEvent) {
          window.trackEvent('purchase', ga_data, fb_data);
        }

        onStepChange(2);
        onContentChange(content_text);
        setLoading(false);

      } else {
        handleError(t("errors:failedToFindOrderResult"));
      }
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className="payment-form">
      <OrderSummary
        items={items}
        frequency={frequency}
      />

      <PayPalScriptProvider options={initialOptions}>
        <PayPalButtons
          style={style}
          createOrder={createOrder}
          onApprove={handlePaypalPaymentApproval}
          fundingSource="paypal"
          disabled={loading}
        />
      </PayPalScriptProvider>
    </div>

  )
};

PaypalPaymentForm.propTypes = {
  items: PropTypes.array.isRequired,
  createOrder: PropTypes.func,
  onShowTickets: PropTypes.func,
  onStepChange: PropTypes.func,
  onContentChange: PropTypes.func,
};

export default PaypalPaymentForm;
